import React, { useEffect } from "react";
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
// import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import i18n from "../../locales";

const useStyles = makeStyles((theme) => ({
    formControl: {
        // margin: theme.spacing(1),
        height: 36,
        minWidth: 150,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    inputLabel: {
        fontSize: theme.spacing(3)
    },
    select: {
        fontSize: theme.spacing(2),
        color: ''
    },
    menuItem: {
        fontSize: theme.spacing(2)
    }
}));

const Language = (props) => {
    const classes = useStyles();
    const [locale, setLocale] = React.useState('en');
    const [display, setDisplay] = React.useState(true);

    useEffect(() => {
        const query = useQuery();
        const languageFromUrl = query.get("lang") ? query.get("lang") : '';
        if (languageFromUrl) setDisplay(false)
        const locale = localStorage.getItem('language')
        if (locale) setLocale(locale);
    }, [locale]);

    const handleChange = (event) => {
        // event.persist();
        const locale = event.target.value;
        setLocale(locale);
        localStorage.setItem('language', locale);
        i18n.changeLanguage(locale);
    }

    const useQuery = () => {
        return new URLSearchParams(window.location.search);
    }

    return (
        <div className="language-container" style={{display: display ? '' : 'none'}}>
            <FormControl className={classes.formControl}>
                {/* <InputLabel className={classes.inputLabel} shrink id="demo-simple-select-outlined-label">Language</InputLabel> */}
                <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={locale}
                    onChange={handleChange}
                    label="Language"
                    className={classes.select}
                >
                    <MenuItem className={classes.menuItem} value={'en'}>English</MenuItem>
                    <MenuItem className={classes.menuItem} value={'es'}>Español</MenuItem>
                    <MenuItem className={classes.menuItem} value={'fr'}>Français</MenuItem>
                    <MenuItem className={classes.menuItem} value={'ge'}>Deutsch</MenuItem>
                    <MenuItem className={classes.menuItem} value={'it'}>Italiano</MenuItem>
                    <MenuItem className={classes.menuItem} value={'jp'}>日本語</MenuItem>
                    <MenuItem className={classes.menuItem} value={'sc'}>简体中文</MenuItem>
                    <MenuItem className={classes.menuItem} value={'tc'}>繁体中文</MenuItem>
                    <MenuItem className={classes.menuItem} value={'ar'}>بالعربية</MenuItem>
                </Select>
            </FormControl>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        login: state.login,
    }
}

export default connect(
    mapStateToProps
)(Language);



// WEBPACK FOOTER //
// ./src/js/containers/Language.jsx